import { useSyncExternalStore } from 'react';

// the channel a zap is on before it commits, outside the store so only the preview re-renders
export interface ZapPreview {
  channelId: string;
  position: number;
}

let preview: ZapPreview | undefined;
const listeners = new Set<() => void>();

export const getZapPreview = () => preview;

export const setZapPreview = (next?: ZapPreview) => {
  if (preview?.channelId === next?.channelId && preview?.position === next?.position) {
    return;
  }
  preview = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useZapPreview = () => useSyncExternalStore(subscribe, getZapPreview);
